import React from "react";

/**
 * The claims screens' switch (#11422 rounds 11 and 12b): the RMS control,
 * an ink track with the knob at the right when on, a hairline track with
 * the knob at the left when off. A switch reads as on or off at arm's
 * length, which a small check did not. One control for Keyboard mode in the
 * keys overlay and for the Decision panel's Priority row.
 *
 * Named by `label`, or by the `<label>` it sits in when `label` is left out.
 */
const ClaimsSwitch: React.FC<{
  on: boolean;
  onChange: (on: boolean) => void;
  label?: string;
  disabled?: boolean;
  onFocus?: (event: React.FocusEvent<HTMLButtonElement>) => void;
  onBlur?: () => void;
}> = ({ on, onChange, label, disabled = false, onFocus, onBlur }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange(!on)}
    onFocus={onFocus}
    onBlur={onBlur}
    style={{
      width: 36,
      height: 20,
      flex: "none",
      borderRadius: 999,
      padding: 2,
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: on ? "flex-end" : "flex-start",
      background: on ? "var(--fp-ink)" : "var(--fp-bg-well)",
      border: `1px solid ${on ? "var(--fp-ink)" : "var(--fp-border-strong)"}`,
      transition: "background-color 120ms ease",
    }}
  >
    <span
      aria-hidden
      style={{
        width: 14,
        height: 14,
        borderRadius: 999,
        background: "var(--fp-surface)",
        boxShadow: "var(--fp-lift)",
      }}
    />
  </button>
);

export default ClaimsSwitch;
